import React, { useState } from "react";
import { Box, TextInput, Text, UnstyledButton, Popover } from "@mantine/core";

export default function FilterTextInput({ value, isEditMode, onChange, TargetComponent }) {
  const [opened, setOpened] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(typeof value === "string" ? value : "");

  const handleUpdate = () => {
    setIsEditing(false);
    setOpened(false);
    if (typeof onChange === "function") {
      onChange(text);
    }
  };

  const closePopover = () => {
    setOpened(false);
    setIsEditing(false);
  };

  return (
    <Popover
      opened={isEditMode ? opened : false}
      onClose={isEditMode ? closePopover : undefined}
      position="bottom"
      placement="start"
      zIndex={99999}
      spacing={0}
      target={
        TargetComponent ? (
          <TargetComponent onClick={() => setOpened(!opened)} />
        ) : (
          <Box>
            {isEditing ? (
              <TextInput
                value={text}
                size="sm"
                onChange={(e) => setText(e.currentTarget.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleUpdate()}
              />
            ) : (
              <UnstyledButton
                py={2}
                sx={{ "&:hover": isEditMode && { backgroundColor: "lightgrey" }, borderRadius: 5 }}
                onClick={isEditMode ? () => setIsEditing(true) : undefined}
              >
                <Text color={text.length > 0 ? "dark" : "grey"} size="sm">
                  {text.length > 0 ? text : "Empty"}
                </Text>
              </UnstyledButton>
            )}
          </Box>
        )
      }
    >
     {TargetComponent ? (
        <TextInput
          value={text}
          size="xs"
          onChange={(e) => setText(e.currentTarget.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleUpdate()}
          m={8}
        />
     ) : null}
    </Popover>
  );
}